const lsg_slidecart_rebuild = { 
    init: () => {

        
        const slideCartEl       = document.querySelector(`.lsg-slidecart-rebuild`),
              formatter         = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', }),
              currentPath       = window.location.pathname;

        if (slideCartEl && currentPath != '/cart') {

            /* iOS scroll locking */
            let scrollY;
            // window.addEventListener('resize', () => {
            //     measure.style.setProperty('--height', `${window.innerHeight}px`);
            // });
            function syncHeight() {
                document.documentElement.style.setProperty(
                    '--window-inner-height',
                    `${window.innerHeight}px`
                );
            }
            syncHeight();
            window.addEventListener('resize', syncHeight);
    
            const slideCartOverlayEl    = document.querySelector(`[lsg-slidecart-rebuild-overlay]`),
                  openBtnEls            = document.querySelectorAll('[lsg-slidecart-open]'),
                  closeBtnEls           = document.querySelectorAll('[lsg-slidecart-rebuild-close]'),
                  productFormEls        = document.querySelectorAll('.shopify-product-form'),
                  alertEl               = document.querySelector(`[lsg-slidecart-rebuild-alert]`),
                  alertLength           = 5000;
            
            // Alert user about errors
            let alertTimer;
            function alertUser(msg) {
                if (alertEl.classList.contains(`lsg-alert-active`)) {
                    clearTimeout(alertTimer);
                }
                alertEl.textContent = msg;
                alertEl.classList.add(`lsg-alert-active`);
                alertTimer = setTimeout(() => {
                    alertEl.classList.remove(`lsg-alert-active`);
                }, alertLength);
            }
    
            // Main Slidecart opening process
            function slideCartOpen() {
                slideCartEl.classList.add(`lsg-slidecart-rebuild__active`);
                slideCartOverlayEl.classList.add(`lsg-slidecart-rebuild__active`);
                scrollY = window.scrollY; // remember scroll position
                document.documentElement.classList.add('is-locked'); // lock document
                slideCartEl.addEventListener('pointermove', (e) => { e.preventDefault }); // block pointer events
            }
    
            // Open the Slidecart accessible externally in the window
            window.LSG_OPEN_CART = function LSG_OPEN_CART() {
                slideCartOpen();
            }
    
            // Ask the Slidecart to re-render itself
            window.LSG_CART_UPDATE = function LSG_CART_UPDATE() {
                slideCartEl.classList.add(`lsg-slidecart-rebuild__active`);
                slideCartOverlayEl.classList.add(`lsg-slidecart-rebuild__active`);
            }
    
            // Open slidecart if #cart present in window location
            // Used with redirect from /cart to /#cart to obfuscate cart template
            if (window.location.href.indexOf("#cart") > -1) {
                slideCartOpen();
            }
    
            // Close the Slidecart
            function slideCartClose() {
                slideCartEl.classList.remove(`lsg-slidecart-rebuild__active`);
                slideCartOverlayEl.classList.remove(`lsg-slidecart-rebuild__active`);
                document.documentElement.classList.remove('is-locked'); // unlock document
                slideCartEl.removeEventListener('pointermove', (e) => { e.preventDefault }); // resume pointer events
                window.scrollTo(0, scrollY); // restore scroll position
            }
    
            // Event listeners
            openBtnEls.forEach((openBtnEl) => {
                openBtnEl.addEventListener('click', (e) => {
                    e.preventDefault();
                    slideCartOpen();
                });
            });
    
            closeBtnEls.forEach((closeBtnEl) => {
                closeBtnEl.addEventListener('click', (e) => {
                    slideCartClose();
                });
            });
    
            // Take over processing of ATC from standard Shopify product forms
            productFormEls.forEach((productFormEl) => {
                return;
                productFormEl.addEventListener('submit', (e) => {
                    e.preventDefault();
    
                    const addOnToggleEl = productFormEl.querySelector(`.lsg-add-on-toggle__item input[type="radio"]:checked`);
                    let addOnProduct = 'none';
                    if (addOnToggleEl) {
                        addOnProduct = addOnToggleEl.value
                    }
    
                    let formData = new FormData(e.target);
                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(Object.fromEntries(formData))
                    })
                    .then(response => { return response.json(); })
                    .then(data => {
                        if (data.status) {
                            console.error(`${data.message}: Status ${data.status} - ${data.description}`);
                            alertUser(data.message);
                        } else {
                            if (addOnProduct && addOnProduct !== 'none') {
                                addAddOn(addOnProduct);
                            } else {
                                slideCartOpen();
                            }
                        }
                    })
                    .catch((error) => { console.error('Error:', error); });
                });
            });
    
            function addAddOn(addOnProduct) {
                var data = {
                    "id": addOnProduct,
                    "quantity": 1
                };
    
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                })
                .then(response => { return response.json(); })
                .then(data => {
                    if (data.status) {
                        console.error(`${data.message}: Status ${data.status} - ${data.description}`);
                        alertUser(data.message);
                    } else {
                        slideCartOpen();
                    }
                })
                .catch((error) => { console.error(`Error:`, error); });
            }

    
            /**
             * Theme Editor Support
             */
            document.addEventListener(`shopify:section:select`, e => {
                if (e.target.contains(slideCartEl)) {
                    slideCartOpen();
                }
            });
    
            document.addEventListener(`shopify:section:deselect`, e => {
                if (e.target.contains(slideCartEl)) {
                    slideCartClose();
                }
            });

        }
        

    }
}
export default lsg_slidecart_rebuild;